import { Card, CardContent } from '@material-ui/core';
import React from 'react';
import { geolocated } from 'react-geolocated';

let Enlem = 'E';
let Boylam = 'B';

export function GetLocation() {
  navigator.geolocation.getCurrentPosition(success, error, options);
}
function success(pos) {
  const crd = pos.coords;
  Enlem = crd.latitude;
  Boylam = crd.longitude;
}

function error(err) {}
var options = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0
};
class GeoLocation extends React.Component {
  render() {
    GetLocation();
    return (
      <Card>
        <CardContent>
          <iframe
            title="Konum"
            display="initial"
            height="250px"
            width="100%"
            frameBorder="0"
            src={`https://maps.google.com/maps?q=${Enlem},${Boylam}&hl=es;z=14&output=embed`}
          />
        </CardContent>
      </Card>
    );
  }
}
export default geolocated({
  positionOptions: {
    enableHighAccuracy: true
  },
  userDecisionTimeout: 5000
})(GeoLocation);
